<template>
  <div  class="menu-icon">
    <div class="line"></div>
    <div class="line"></div>
    <div class="line"></div>
  </div>
</template>

<script>
export default { 
    name: "MenuIcon",
};
</script>

<style>
.menu-icon {
  position: fixed;
  top: 2.5vh;
  left: 1.5vh;
  z-index: 99;
}
.menu-icon > .line {
  background: white;
  width: 28px;
  height: 2px;
  margin-bottom: 7px;
  z-index: 999;
}
</style>